module.exports = __webpack_public_path__ + "static/media/badge_dropdown.683bfc9d.svg";